module.exports = __webpack_public_path__ + "static/rcr.a5a4e0ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/apps/rcr.png
// module id = 862
// module chunks = 11078321823668 107301235873723